import {
	ADDITIONAL_VALIDATION_ERROR_SEPARATOR,
	IWithAdditionalValidationState,
} from './withAdditionalValidationContext';
import { TWithAdditionalValidationAction, WithAdditionalValidationActions } from './withAdditionalValidationActions';

export const withAdditionalValidationReducer = (
	state: IWithAdditionalValidationState,
	action: TWithAdditionalValidationAction,
): IWithAdditionalValidationState => {
	switch (action.type) {
		case WithAdditionalValidationActions.SET_MAIN_FORM_VALIDATION_FAIL:
			return {
				...state,
				mainFormValidationFail: action.payload.failStatus,
			};
		case WithAdditionalValidationActions.ADD_ADDITIONAL_VALIDATION_ERROR:
			return {
				...state,
				additionalValidationErrors: [...state.additionalValidationErrors, action.payload.validationError],
			};
		case WithAdditionalValidationActions.REMOVE_ADDITIONAL_VALIDATION_ERROR:
			return {
				...state,
				additionalValidationErrors: state.additionalValidationErrors.filter(
					(el) => el.validationErrorId !== action.payload.errorId,
				),
			};
		case WithAdditionalValidationActions.REMOVE_ALL_ADDITIONAL_VALIDATION_ERRORS_IN_BLOCK:
			return {
				...state,
				additionalValidationErrors: state.additionalValidationErrors.filter((el) => {
					const blockId = el.validationErrorId.slice(
						0,
						el.validationErrorId.indexOf(ADDITIONAL_VALIDATION_ERROR_SEPARATOR),
					);
					return blockId !== action.payload.blockId;
				}),
			};
		default:
			return state;
	}
};
